import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const Label = styled.div`
    ${mixins.setFontVariant("tag", colorsPalettes.carbon["400"])};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 4px 6px;
    background: ${colorsPalettes.carbon["25"]};
    line-height: 8px;
    height: 16px;
    display: flex;
    align-items: center;
`;
